import { Box, Button, ButtonProps, styled } from "@mui/material";

export const DialogSectionGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: theme.spacing(2),
}));

interface IPositionSelectionButton {
  selected?: boolean;
}

export const PositionSelectionButton = styled((props: ButtonProps) => (
  <Button {...props} variant="contained" />
))<IPositionSelectionButton>(({ theme, selected = false }) => ({
  height: "fit-content",
  minWidth: "unset",
  maxWidth: theme.spacing(6.5),
  border: "2px solid",
  borderColor: theme.palette.dsSurface.v200,
  borderRadius: theme.spacing(1.5),
  backgroundColor: selected ? theme.palette.dsBase.v200 : theme.palette.dsSurface.v200,
  padding: theme.spacing(2, 1.5),
  color: selected ? theme.palette.dsBase.v100 : theme.palette.dsNeutral.v200,
  fontFamily: theme.typography.textBase700.fontFamily,
  fontSize: theme.typography.textBase700.fontSize,
  fontWeight: theme.typography.textBase700.fontWeight,
  lineHeight: theme.typography.textBase700.lineHeight,
  ":hover": {
    color: theme.palette.dsBase.v100,
    backgroundColor: theme.palette.dsNeutral.v200,
  },
}));
